module.exports = __webpack_public_path__ + "media/MRI-ExemploC.96534c98.mp3";